import React from 'react';
import { TabTableContainer, Title } from '@screens/players/player.details.tabs/tabs.tables.styles';
import { PlayerDataProps } from '@screens/players/types/player.data.props';
import { useAuth } from '@domain/auth/auth.hook';
import { CancelToken } from 'axios';
import { usePagedData } from '@domain/hooks/use.paged.data';
import { noopArray } from '@domain/utils/function.utils';
import { MainDataGrid } from '@components/datagrid/main.data.grid';
import { formatColWithDate } from '@components/datagrid/custom.datagrid.props';

const columns = [
  { field: 'promo', headerName: 'Promo', width: 180 },
  { field: 'task', headerName: 'Task', width: 180 },
  { field: 'taskParam', headerName: 'Task Param', width: 180 },
  { field: 'taskCount', headerName: 'Task Count', width: 180 },
  { field: 'taskRequired', headerName: 'Task Required', width: 180 },
  { field: 'category', headerName: 'Category', width: 180 },
  { field: 'scheduleStartDate', headerName: 'Schedule Start Date', ...formatColWithDate, width: 150 },
  { field: 'scheduleEndDate', headerName: 'Schedule End Date', ...formatColWithDate, width: 150 },
  { field: 'startDate', headerName: 'Start', ...formatColWithDate, width: 150 },
  { field: 'closureDate', headerName: 'Closure', ...formatColWithDate, width: 150 },
  { field: 'coins', headerName: 'Coins', width: 150 },
  { field: 'cash', headerName: 'Cash', width: 150 },
];

interface PromosTasksData {
  promo: number;
  task: string;
  taskParam: string;
  taskCount: string;
  taskRequired: string;
  category: string;
  scheduleStartDate: string;
  scheduleEndDate: string;
  startDate: string;
  closureDate: string;
  coins: number;
  cash: number;
}

let index = 0;
function createData(promosTasksData: PromosTasksData) {
  index += 1;
  return { id: index, ...promosTasksData };
}

const PromosTasks = ({ player }: PlayerDataProps) => {
  const { authorizedServices } = useAuth();
  const { pid } = player;
  const praia = 'BOTH';

  async function runSearch(data: any, page: number, cancelToken: CancelToken | undefined) {
    return authorizedServices.get<PromosTasksData[]>(`/admin/promos/tasks/`, { params: { pid, praia, page }, cancelToken });
  }
  const { responseData, pageCount, loading, error } = usePagedData(pid, runSearch, { placeholderData: noopArray });

  const rows = responseData?.map(createData) || [];
  // const rows = responseData || [];

  const total = rows.length;
  return (
    <>
      <TabTableContainer>
        <Title>Promo Tasks ({total})</Title>
        <MainDataGrid columns={columns} rows={rows} loading={loading} error={error} pageCount={pageCount} />
      </TabTableContainer>
    </>
  );
};

export default PromosTasks;
